module.exports = __webpack_public_path__ + "static/img/product09-3.511804a2.png";